import { Card, Grid, Typography } from "@mui/material";
import { ApprovalGradeResult } from "src/grading/models";
import { TestScore } from "src/store/reducers/scores/scoresApiSlice";
import useStyles from "./ResultsApprovalCard.styles";

type ResultsApprovalCardProps = ApprovalGradeResult & {
  fileKey: string | undefined;
  step: number;
  startTime?: number;
  endTime?: number;
  metadata?: any;
  grade?: string;
  score?: number;
  maxScore?: number;
  testScore?: TestScore;
};

export default function ResultsApprovalCard(props: ResultsApprovalCardProps) {
  const classes = useStyles();

  // const distanceInMiles = props?.userResult?.distance;

  // const approved = props?.approved || props?.grade !== "Fail";

  return (
    <Grid container spacing={2} xs={12}>
      <Card className={classes.gradingReviewCard}>
        <Grid container xs={12} mx={4} my={3} gap={1} flexDirection={"row"}>
          <Grid
            container
            item
            flexDirection={"column"}
            xs={7}
            justifyContent={"center"}
          >
            <Typography variant="h4">
              {props?.userResult?.name || props?.metadata?.name}
            </Typography>
          </Grid>

          <Grid item flexDirection={"column"} mr={1.5}>
            <Typography variant="subtitle1">Score</Typography>

            <Typography variant="caption" fontSize={"18px"}>
              {props?.testScore?.exercises[props?.step].score?.toString()}
              <span style={{ color: "#8F8F8F" }}>
                /{props?.testScore?.exercises[props?.step].maxScore}
              </span>
            </Typography>
          </Grid>
          <Grid item flexDirection={"column"}>
            <Typography variant="subtitle1">Ranking</Typography>

            <Typography variant="caption" fontSize={"18px"}>
              {props?.testScore?.exercises[props?.step]?.grade ||
                props?.testScore?.exercises[props?.step].grade ||
                "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
